import Styled from "styled-components";
import { px2rem } from "utils/browser/resizer";

const PictureTagBase = Styled.img`
	position: absolute;
	z-index: 2;
`;

export const NewRightTopTag = Styled(PictureTagBase)`
	top: 0;
	right: 0;
	border-radius: 0 0.25rem 0px 0;
	transform: scale(0.333);
    transform-origin: top right;
	max-height: 100%;
`;

export const LeftTopTags = Styled.div`
	top: 0;
	left: 0;
	position: absolute;
	z-index: 2;
	border-top-left-radius: 0.25rem;
	border-bottom-right-radius: ${px2rem(8)};
	>img{
		height: ${px2rem(16)};
		width: auto;
		object-fit: cover;
		&:first-child{
			border-top-left-radius: ${px2rem(4)};
		}
		&:last-child{
			border-bottom-right-radius: ${px2rem(8)};
		}
	}	
`;

export const LeftBottomTag = Styled(PictureTagBase)`
	height: 1.375rem;
	bottom: 0;
	left: 0;
`;
